/**
 * The STEP (ISO 10303-21) entity writer: numbers each entity in the order it
 * is written and keeps the DATA section's lines, plus the encodings STEP
 * values need.
 */

import { type Vec3 } from '../math3d';

export interface StepWriter {
  /** Writes one entity and returns its reference ("#12"). */
  entity: (body: string) => string;
  direction: (vector: Vec3) => string;
  cartesianPoint: (point: Vec3) => string;
  /** The DATA section's lines, in writing order. */
  data: string[];
}

/** STEP reals must contain a decimal point ("3048." not "3048"). */
const real = (n: number): string => n.toFixed(6).replace(/(\.\d*?)0*$/, '$1').replace(/\.$/, '.0').replace(/^-0\.0$/, '0.0');

/** STEP strings escape apostrophes by doubling; backslash starts an escape. */
export const stepString = (text: string): string => text.replace(/\\/g, '\\\\').replace(/'/g, "''");

export function createStepWriter(): StepWriter {
  let nextId = 1;
  const data: string[] = [];
  const entity = (body: string): string => {
    const reference = `#${nextId++}`;
    data.push(`${reference}=${body};`);
    return reference;
  };
  return {
    entity,
    direction: ([x, y, z]) => entity(`DIRECTION('',(${real(x)},${real(y)},${real(z)}))`),
    cartesianPoint: ([x, y, z]) => entity(`CARTESIAN_POINT('',(${real(x)},${real(y)},${real(z)}))`),
    data,
  };
}
